import get from 'lodash.get';
import { PaymentErrorCodes } from '~app/modules/checkout/models';
import {
  GaTrackingEventAction,
  GaTrackingEventCategory,
  GaTrackingEventName,
  GATrackingEventType
} from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';

export class GATrackingPaymentFailureEvent implements GATrackingEvent {

  constructor(
    private error: any,
    private payment: any
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PaymentFailure;
  }

  getPayload(): GATrackingEventPayload {
    let errorCode = this.error;
    let label = 'Payment failed';

    if (this.error === 'Validation error') {
      errorCode = PaymentErrorCodes.GENERAL_VALIDATION_ERROR;
      label += ' - Validation error';
    }

    if (this.error?.message) {
      label = this.error.message;
    }

    const category = GaTrackingEventCategory.Errors;
    const action = GaTrackingEventAction.CheckoutErrors;
    return {
      event: GaTrackingEventName.Errors,
      category,
      label,
      gtmCustom: {
        errorCode,
        category,
        action,
        payment_method: this.payment?.paymentMethod?.type,
        'payment_date-of-birth': Boolean(get(this.payment, 'additionalInformation.dateOfBirth', ''))
      }
    };
  }

}
